<form [formGroup]="eventInfo" class="form-create-event">

  <!-- ─── Card 1: Información básica ─────────────────────────── -->
  <div class="create-card" *ngIf="isCardVisible('info')">
    <div id="section-info-event" class="create-card-header section-toggle" (click)="toggleCard('info')">
      <i class="fal fa-file-lines create-card-icon"></i>
      <h3 class="create-card-title">Información del evento</h3>
      <div class="ms-auto d-flex align-items-center gap-2">
        <i class="fal fa-check-circle check-icon check-green" *ngIf="infoSectionComplete && !onlyCard"></i>
        <i class="fal fa-chevron-down section-chevron" [class.chevron-open]="openCards['info']"></i>
      </div>
    </div>
    <div class="create-card-body info-main-grid" *ngIf="isCardOpen('info')" [@slideDown]>

      <div class="info-fields-col">
        <!-- Categorías -->
        <div class="field-row">
          <label class="field-label">Categoría <span class="required-field">*</span></label>
          <div class="categories-inline-row">
            <span class="category-chip" *ngFor="let cat of categoriesSelected">
              <i class="fal {{ cat.icon }}"></i>
              {{ cat.name }}
              <i class="fa-light fa-times chip-remove" (click)="removeCategory(cat)"></i>
            </span>
            <button type="button" class="btn-add-category" (click)="openCategories()">
              <i class="fa-light fa-plus"></i> Añadir categoría
            </button>
          </div>
        </div>

        <!-- Título -->
        <div class="field-row">
          <label class="field-label">Título <span class="required-field">*</span></label>
          <input class="create-input" formControlName="title" type="text" placeholder="Escribe el título del evento">
        </div>

        <!-- URL de venta externa — solo para eventos de venta externa -->
        <div class="field-row" *ngIf="eventType === 'external'">
          <label class="field-label">URL de venta externa <span class="required-field">*</span></label>
          <p class="create-hint">Los usuarios serán redirigidos aquí para comprar sus entradas.</p>
          <input class="create-input" formControlName="external_url" type="text" placeholder="https://...">
        </div>

        <!-- Descripción -->
        <div class="field-row">
          <label class="field-label">Descripción <span class="required-field">*</span></label>
          <angular-editor #edit id="1" formControlName="description" [config]="editorConfig">
            <ng-template #customButtons let-executeCommandFn="executeCommandFn">
              <ae-toolbar-set class="button-styles-text" tabindex="">
                <emoji-mart class="emoji-mart" *ngIf="isEmojiPickerVisible" [enableSearch]="false"
                  [showPreview]="false" (emojiSelect)="executeCommandFn('insertHtml', addEmoji($event))"></emoji-mart>
                <button class="btn-style btn-bold" (click)="executeCommandFn('bold')"><strong>N</strong></button>
                <button class="btn-style btn-italic" (click)="executeCommandFn('italic')"><i>K</i></button>
                <button class="btn-style btn-underline" (click)="executeCommandFn('underline')"><u>S</u></button>
                <button class="btn-emoji pointer-in" (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">
                  <i class="fa-light fa-face-smile"></i>
                </button>
              </ae-toolbar-set>
            </ng-template>
          </angular-editor>
        </div>
      </div>

      <!-- Foto de portada -->
      <div class="info-photo-col">
        <label class="field-label">Foto de portada <span class="required-field">*</span></label>
        <div class="cover-photo-box" (click)="file.click()">
          <i class="fa-thin fa-image" *ngIf="!imgControl.value"></i>
          <img [src]="imgControl.value" alt="Portada" *ngIf="imgControl.value" />
          <div class="cover-photo-overlay">
            <i class="fa-light fa-arrow-up-from-bracket"></i>
          </div>
        </div>
        <input id="file" #file hidden type="file" accept="image/jpeg,image/png,image/webp,image/gif" (change)="onFileChange($event)">
      </div>

    </div>
  </div>

  <!-- ─── Card 2: Lugar y aforo ───────────────────────────────── -->
  <div class="create-card" *ngIf="isCardVisible('lugar')">
    <div id="section-lugar-event" class="create-card-header section-toggle" (click)="toggleCard('lugar')">
      <i class="fal fa-location-dot create-card-icon"></i>
      <h3 class="create-card-title">Lugar y aforo</h3>
      <div class="ms-auto d-flex align-items-center gap-2">
        <i class="fal fa-check-circle check-icon check-green" *ngIf="lugarSectionComplete && !onlyCard"></i>
        <i class="fal fa-chevron-down section-chevron" [class.chevron-open]="openCards['lugar']"></i>
      </div>
    </div>
    <div class="create-card-body" *ngIf="isCardOpen('lugar')" [@slideDown]>

      <!-- Paso 1: Tipo de ubicación -->
      <div class="field-row">
        <label class="field-label">Ubicación <span class="required-field">*</span></label>

        <!-- Toggle de tipo de ubicación (bloqueado al editar un evento con mapa de butacas) -->
        <p class="create-hint" *ngIf="isPlaceLocked()">El lugar no se puede cambiar en un evento con mapa de butacas ya creado.</p>
        <p class="create-hint" *ngIf="eventType === 'external'">Los eventos de venta externa solo llevan dirección, sin espacio ni aforo.</p>
        <div class="location-option-cards" *ngIf="!isPlaceLocked() && eventType !== 'external'">
          <div class="location-option-card" [class.active]="!otherAddress"
              (click)="selectSpaceMode()">
            <div class="location-option-icon">
              <i class="fal fa-building"></i>
            </div>
            <div class="location-option-text">
              <span class="location-option-name">Espacio asociado</span>
              <span class="location-option-desc">Espacios de tu organización</span>
            </div>
          </div>
          <div class="location-option-card" [class.active]="otherAddress"
              (click)="selectOtherAddressMode()">
            <div class="location-option-icon">
              <i class="fal fa-map-pin"></i>
            </div>
            <div class="location-option-text">
              <span class="location-option-name">Otra dirección</span>
              <span class="location-option-desc">Dirección libre del evento</span>
            </div>
          </div>
        </div>

        <!-- Si ya hay espacio seleccionado -->
        <div class="selected-place-row" *ngIf="space && !otherAddress">
          <img class="selected-place-img" [src]="urlImagesVenues + space.img_url" [alt]="space.name">
          <span class="selected-place-name">{{space.name}}</span>
          <button class="selected-place-clear" *ngIf="!isPlaceLocked()" (click)="changePlace(null)" matTooltip="Cambiar lugar">
            <i class="fal fa-xmark"></i>
          </button>
        </div>

        <!-- Campos: Espacio asociado -->
        <div *ngIf="!space && !otherAddress" [@slideDown]>
          <div *ngIf="!loading && placeList.length <= 0">
            <p class="create-hint">No hay lugares disponibles para tu organización.</p>
          </div>
          <app-card-select *ngIf="placeList.length > 0" class="place-select" [options]="placeOptions"
            [value]="space?.id" placeholder="Seleccionar espacio" emptyMessage="No hay espacios disponibles"
            (valueChange)="onPlaceSelected($event)">
          </app-card-select>
        </div>

        <!-- Campos: Otra dirección -->
        <div *ngIf="otherAddress" [@slideDown]>
          <div class="location-search-container">
            <i class="fal fa-map-marker-alt location-search-icon"></i>
            <input id="searchMap" #search type="text" class="location-search-input"
              placeholder="Escribe la dirección del evento..."
              [(ngModel)]="lugar" name="location" (input)="onSearchPlaces()" (blur)="onBlurAddress()"
              [matAutocomplete]="auto" [ngModelOptions]="{standalone: true}">
          </div>
          <mat-autocomplete (optionSelected)="onSelectPlace(search.value)" #auto="matAutocomplete"
            [displayWith]="displayFn">
            <mat-option *ngFor="let option of searchResults" [value]="option" class="item-option-map">
              <div class="item-option">
                <i class="fa-solid fa-location-dot"></i>
                <span>{{option.description}}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
          <div class="container-map">
            <div id="maplock"></div>
          </div>
        </div>
      </div>

      <!-- Paso 2: Tipo de aforo (solo si hay espacio seleccionado) -->
      <div class="field-row aforo-section" *ngIf="space">
        <label class="field-label">Tipo de aforo</label>
        <p class="create-hint" *ngIf="isCapacityTypeLocked()">El tipo de aforo no se puede cambiar una vez creado el evento.</p>
        <div class="capacity-type-selector">
          <div class="capacity-type-card"
            [class.active]="eventInfo.value.use_map === true"
            [class.disabled]="isCapacityTypeLocked() || !space?.has_map || !space?.current_version"
            (click)="!isCapacityTypeLocked() && space?.has_map && space?.current_version && eventInfo.get('use_map').setValue(true); !isCapacityTypeLocked() && space?.has_map && space?.current_version && changeUseMap()">
            <i class="fal fa-chair capacity-type-icon"></i>
            <div class="capacity-type-text">
              <span class="capacity-type-name">Mapa de butacas</span>
              <span class="capacity-type-desc">
                {{ (space?.has_map && space?.current_version) ? 'Asientos numerados con plano del espacio' : 'Este espacio no tiene mapa configurado' }}
              </span>
            </div>
          </div>
          <div class="capacity-type-card" [class.active]="eventInfo.value.use_map === false"
            [class.disabled]="isCapacityTypeLocked()"
            (click)="!isCapacityTypeLocked() && eventInfo.get('use_map').setValue(false); !isCapacityTypeLocked() && changeUseMap()">
            <i class="fal fa-users capacity-type-icon"></i>
            <div class="capacity-type-text">
              <span class="capacity-type-name">Aforo general</span>
              <span class="capacity-type-desc">Sin numeración, entradas de acceso libre</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Aforo / mapa (solo evento normal):
           - Siempre visible con "Otra dirección"
           - Visible con "Espacio asociado" si use_map = false (aforo general)
           - Visible también con mapa de butacas al EDITAR un evento existente,
             para poder ver/gestionar los asientos bloqueados u ocupados -->
      <div *ngIf="eventType === 'normal' && remountMapSeats && (otherAddress || (space && !eventInfo.value.use_map) || (idEvent && space && eventInfo.value.use_map))">
        <app-map-seats-create
          [venue]="space"
          [mapVersion]="eventMapVersion || space?.current_version"
          [useMapVenue]="eventInfo.value.use_map"
          [capacity]="space?.capacity"
          [sessions]="sessions"
          [idEvent]="idEvent">
        </app-map-seats-create>
      </div>

    </div>
  </div>

  <!-- ─── Card 3: Configuración del evento ───────────────────── -->
  <div class="create-card" *ngIf="isCardVisible('config')">
    <div id="section-config-event" class="create-card-header section-toggle" (click)="toggleCard('config')">
      <i class="fal fa-gear create-card-icon"></i>
      <h3 class="create-card-title">Configuración del evento</h3>
      <i class="fal fa-chevron-down section-chevron ms-auto" [class.chevron-open]="openCards['config']"></i>
    </div>
    <div class="create-card-body" *ngIf="isCardOpen('config')" [@slideDown]>

      <!-- Visibilidad -->
      <div class="field-row">
        <label class="field-label">Visibilidad</label>
        <div class="toggle-row">
          <mat-slide-toggle class="toggle-pink" formControlName="hiddenEvent">Evento oculto</mat-slide-toggle>
          <i class="fa-light fa-circle-info icon-primary pointer-in" style="font-size: 12px;" tabindex="0"
            #hiddenEventInfoTooltip="matTooltip" (click)="hiddenEventInfoTooltip.toggle()"
            (keydown.enter)="hiddenEventInfoTooltip.toggle()"
            (keydown.space)="hiddenEventInfoTooltip.toggle(); $event.preventDefault()"
            [matTooltip]="eventInfo.value.hiddenEvent ? 'Solo visible con enlace directo' : 'Visible para todos'"
            matTooltipPosition="above" matTooltipClass="tooltip-info-icon"></i>
        </div>
      </div>

      <!-- Canales de venta — solo tipo normal -->
      <div class="field-row" *ngIf="eventType === 'normal'">
        <label class="field-label">Canales de venta <span class="required-field">*</span></label>
        <p class="create-hint">Elige cómo se vende este evento.</p>
        <div class="sales-channels">
          <div class="channel-card" [class.active]="canalesOnline"
            (click)="selectSalesChannel(false)">
            <mat-radio-button color="primary" [checked]="canalesOnline"
              (click)="$event.stopPropagation(); selectSalesChannel(false)"></mat-radio-button>
            <div class="channel-info">
              <span class="channel-name">Online y Taquilla</span>
              <span class="channel-desc">Venta en Citylok y presencial</span>
            </div>
          </div>
          <div class="channel-card" [class.active]="canalesTaquilla"
            (click)="selectSalesChannel(true)">
            <mat-radio-button color="primary" [checked]="canalesTaquilla"
              (click)="$event.stopPropagation(); selectSalesChannel(true)"></mat-radio-button>
            <div class="channel-info">
              <span class="channel-name">Solo venta en taquilla</span>
              <span class="channel-desc">La venta online queda bloqueada</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Privacidad — solo tiene sentido si hay compra de entradas en Citylok -->
      <div class="field-row" *ngIf="eventType === 'normal'">
        <label class="field-label">Privacidad</label>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <mat-slide-toggle class="toggle-pink" formControlName="private_event">Evento privado</mat-slide-toggle>
          <i class="fa-light fa-circle-info icon-primary pointer-in" style="font-size: 12px;" tabindex="0"
            #privateEventInfoTooltip="matTooltip" (click)="privateEventInfoTooltip.toggle()"
            (keydown.enter)="privateEventInfoTooltip.toggle()"
            (keydown.space)="privateEventInfoTooltip.toggle(); $event.preventDefault()"
            matTooltip="El evento estará visible pero se pedirá un código de acceso para la compra de entradas."
            matTooltipPosition="above" matTooltipClass="tooltip-info-icon"></i>
        </div>
        <div class="private-event-code" *ngIf="eventInfo.value.private_event">
          <input class="create-input" formControlName="private_event_code" type="text"
            placeholder="Código de acceso">
        </div>
      </div>

      <!-- Facturación — solo tiene sentido si hay cobro gestionado por Citylok -->
      <div class="field-row" *ngIf="eventType === 'normal'">
        <label class="field-label">Facturación</label>
        <mat-slide-toggle class="toggle-pink" formControlName="external_billing">Facturar a nombre de otra empresa</mat-slide-toggle>
        <div *ngIf="eventInfo.value.external_billing" class="billing-fields">
          <input class="create-input" formControlName="invoice_business_cif" type="text" placeholder="CIF *">
          <input class="create-input" formControlName="invoice_business_name" type="text"
            placeholder="Nombre de empresa *">
          <!-- Opcional: solo sale en la cabecera del informe resumido del evento -->
          <input class="create-input" formControlName="invoice_business_address" type="text" maxlength="255"
            placeholder="Dirección fiscal">
        </div>
      </div>

      <!-- Gastos de gestión — a qué empresa se atribuyen en la entrada, independiente de la
           facturación del evento. Solo Citylok lo configura: los controles siguen en el
           formulario para el resto de roles (si no, el diff de edición los daría por cambiados),
           pero no se muestran ni se pueden editar. -->
      <div class="field-row" *ngIf="eventType === 'normal' && isSuperAdmin">
        <label class="field-label">Gastos de gestión</label>
        <mat-slide-toggle class="toggle-pink" formControlName="external_fee_billing">Atribuir los gastos de gestión a otra empresa</mat-slide-toggle>
        <div *ngIf="eventInfo.value.external_fee_billing" class="billing-fields">
          <input class="create-input" formControlName="fee_invoice_business_cif" type="text" placeholder="CIF *">
          <input class="create-input" formControlName="fee_invoice_business_name" type="text"
            placeholder="Nombre de empresa *">
        </div>
      </div>

      <!-- Precio desde — solo tiene sentido una vez el evento existe y vende entradas en Citylok -->
      <div class="field-row" *ngIf="idEvent && eventType === 'normal'">
        <label class="field-label">Precio desde</label>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <mat-slide-toggle class="toggle-pink" formControlName="useCustomPrice">Usar precio personalizado</mat-slide-toggle>
          <i class="fa-light fa-circle-info icon-primary pointer-in" style="font-size: 12px;" tabindex="0"
            #customPriceInfoTooltip="matTooltip" (click)="customPriceInfoTooltip.toggle()"
            (keydown.enter)="customPriceInfoTooltip.toggle()"
            (keydown.space)="customPriceInfoTooltip.toggle(); $event.preventDefault()"
            matTooltip="Elige el precio que se mostrará al público en vez del calculado automáticamente a partir de la entrada más barata."
            matTooltipPosition="above" matTooltipClass="tooltip-info-icon"></i>
        </div>
        <p class="create-hint" *ngIf="!eventInfo.value.useCustomPrice">
          Se muestra automáticamente el precio más bajo de entre todas las entradas activas.
        </p>
        <div class="custom-price-field" *ngIf="eventInfo.value.useCustomPrice">
          <input class="create-input field-input--medium" formControlName="customFromPrice" type="number" min="0"
            placeholder="Ej: 12.50">
        </div>
      </div>

    </div>
  </div>

  <!-- ─── Card 4: Multimedia ──────────────────────────────────── -->
  <div class="create-card" *ngIf="isCardVisible('multimedia')">
    <div id="section-multimedia-event" class="create-card-header section-toggle" (click)="toggleCard('multimedia')">
      <i class="fal fa-images create-card-icon"></i>
      <h3 class="create-card-title">Multimedia</h3>
      <i class="fal fa-chevron-down section-chevron ms-auto" [class.chevron-open]="openCards['multimedia']"></i>
    </div>
    <div class="create-card-body" *ngIf="isCardOpen('multimedia')" [@slideDown]>

      <div class="field-row">
        <label class="field-label">Carrusel de fotos</label>
        <p class="create-hint">Añade imágenes adicionales del evento</p>
        <div class="multimedia-row">
          <div class="media-thumb" *ngFor="let img of extraImages; let i = index">
            <img [src]="img.cropped" alt="Img extra" />
            <button class="media-thumb-del" (click)="deleteExtraImg(i)" matTooltip="Eliminar">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <input id="extraImg" #extraImg hidden type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple (change)="onExtraImg($event)">
          <div class="media-add-btn" (click)="extraImg.click()">
            <i class="fal fa-arrow-up-from-bracket"></i>
            <span>Subir foto</span>
          </div>
        </div>
      </div>

      <div class="field-row">
        <label class="field-label">Archivo descargable</label>
        <p class="create-hint">Sube un archivo para que los asistentes puedan descargarlo (PDF, PNG o JPG).</p>
        <input id="fileextra" #fileextra hidden type="file" accept="*/application" (change)="onExtraFile($event)">
        <div class="file-upload-area" (click)="fileextra.click()" [class.has-file]="extraFileControl">
          <ng-container *ngIf="!extraFileControl">
            <i class="fal fa-file-arrow-up file-upload-icon"></i>
            <span class="file-upload-text">Subir archivo</span>
            <span class="file-upload-hint">Haz clic para seleccionar un archivo</span>
          </ng-container>
          <ng-container *ngIf="extraFileControl">
            <i class="fal fa-file-check file-upload-icon file-upload-icon--done"></i>
            <span class="file-upload-text">Archivo subido</span>
            <a [href]="extraFileControl" target="_blank" class="file-upload-link" (click)="$event.stopPropagation()">
              <i class="fal fa-eye"></i> Ver archivo
            </a>
          </ng-container>
        </div>
      </div>

      <!-- Vídeo de YouTube -->
      <div class="field-row">
        <label class="field-label"><i class="fa-brands fa-youtube" style="margin-right: 6px;"></i>Vídeo de YouTube</label>
        <input class="create-input field-input--medium"
          [class.create-input--error]="eventInfo.get('youtube_url')?.invalid && eventInfo.get('youtube_url')?.touched"
          formControlName="youtube_url" type="text" placeholder="https://www.youtube.com/watch?v=...">
        <p class="field-error-text"
          *ngIf="eventInfo.get('youtube_url')?.invalid && eventInfo.get('youtube_url')?.touched">
          Este enlace no parece un vídeo de YouTube válido (usa un enlace de youtube.com o youtu.be).
        </p>
      </div>

    </div>
  </div>

</form>

